export default function Statistics(opts={}){
    let container = opts.container
    let chart = opts.chart
    let measurements = opts.measurements

    this.generate = () =>{
        if(chart.statistics){
            let table = "<table class='chart-statistics-table'>"
            table += buildHeader()
            table += "<tbody class='chart-statistics-table-body'><tr>"
            $.each(chart.statistics.list, (name, boolean)=>{
                if(boolean == 'true'){
                    
                    if(name == 'max'){
                        console.log(measurements);
                        table += '<td>'+_.maxBy(measurements, 'value_flu').value_flu/100+'</td>'
                    }
                    if(name == 'average'){
                        table += '<td>'+_.meanBy(measurements, 'value_flu')/100+'</td>'
                    }
                    if(name == 'min'){
                        table += '<td>'+_.minBy(measurements, 'value_flu').value_flu/100+'</td>'
                    }
                    if(name == 'last'){
                        table += '<td>'+_.last(measurements).value_flu/100+'</td>'
                    }
                    if(name == 'diff'){
                        let first = _.first(measurements).value_flu/100
                        let diff = (first - (_.last(measurements).value_flu/100))
                        table += '<td>'+diff * 100 / first+'</td>'
                    }
                    
                }
            })
            table += '</tr></tbody><table>'
            $(container).html(table)
            // $.each(chart.statistics.list, (name, value)=>{
            //     if(name == 'max'){
                    
            //     }
            // })
        }
    }


    function buildHeader(){
        // `<div class='chart-statistics-table-header'>${Object.keys(chart.statistics.list).map((name) => ).join("")}</div>`
        let html = "<thead class='chart-statistics-table-header'><tr>"
        $.each(chart.statistics.list, (name, boolean)=>{
            if(boolean == 'true'){
                html += `<th>${name}</th>`
            }
        })
        return html += "</tr></thead>"

    }
}